import React, { useState, useEffect } from "react";
import {
  ChakraProvider,
  Box,
  Card,
  AbsoluteCenter,
  Center,
  Image,
  FormLabel,
  Button,
  Flex,
  Text,
  Divider,
  Heading,
  VStack,
  Tag,
  HStack,
  SimpleGrid,
  Select,
  Grid,
  GridItem,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Textarea,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { Link, useParams, useLocation } from "react-router-dom";
import { ColorModeSwitcher } from "../ColorModeSwitcher";
import { Nav } from "../containers/Nav";
import { Footer } from "../containers/Footer";
// import { getBrand, updateBrand } from "../actions/brands";
import { getUserProfile, updateUserProfile } from "../actions/users";
import { getUserRatings } from "../actions/ratings";

import config from "../config";

const root = config.REACT_APP_API_URL;
function UserProfile() {
  const toast = useToast();
  const lightGray = useColorModeValue("gray.100", "gray.900");
  const params = useParams();
  const brand = params.brand;

  const search = useLocation().search;
  const setUp = Boolean(localStorage.getItem("register_user_profile"));

  const [userZodiac, setUserZodiac] = useState();
  const [userSocialMedia, setUserSocialMedia] = useState();
  const [userWatching, setUserWatching] = useState();
  const [userTopFilm, setTopFilm] = useState();
  const [userTopTv, setTopTv] = useState();
  const [userTopTheatre, setTopTheatre] = useState();
  const [userTopSong, setTopSong] = useState();
  const [userTopBook, setTopBook] = useState();
  const [userRecc, setRecc] = useState();
  const [movieRatings, setMovieRatings] = useState({});

  const [profileErrors, setProfileErrors] = useState([]);
  const [canSaveChanges, setCanSaveChanges] = useState(true);
  const [changesSaved, setChangesSaved] = useState(false);

  const submitProfile = async () => {
    let errors = [];
    setProfileErrors(errors);

    setCanSaveChanges(false);
    let updateBody = {};

    if (!userZodiac || userZodiac === "") {
      errors = [...errors, "Zodiac is a required field"];
    }
    if (!userSocialMedia || userSocialMedia === "") {
      errors = [...errors, "Social Media is a required field"];
    }
    if (!userWatching || userWatching === "") {
      errors = [
        ...errors,
        "What you're watching right now is a required field",
      ];
    }
    if (!userTopFilm || userTopFilm === "") {
      errors = [...errors, "Top film is a required field"];
    }
    if (!userTopTv || userTopTv === "") {
      errors = [...errors, "Top TV is a required field"];
    }
    if (!userTopTheatre || userTopTheatre === "") {
      errors = [...errors, "Top Theatre is a required field"];
    }
    if (!userTopSong || userTopSong === "") {
      errors = [...errors, "Top Song is a required field"];
    }
    if (!userTopBook || userTopBook === "") {
      errors = [...errors, "Top Book is a required field"];
    }
    if (!userRecc || userRecc === "") {
      errors = [...errors, "Your reccomendation is a required field"];
    }

    if (errors.length) {
      setProfileErrors(errors);
      setCanSaveChanges(true);
      return;
    }

    const response = await updateUserProfile({
      zodiac: userZodiac,
      socialMedia: userSocialMedia,
      watchingNow: userWatching,
      topFilm: userTopFilm,
      topTv: userTopTv,
      topTheatre: userTopTheatre,
      topSong: userTopSong,
      topBook: userTopBook,
      topRecc: userRecc,
    });
    if (response.ok) {
      toast({
        title: `Profile has been saved!`,
        status: "success",
        duration: 4000,
        isClosable: true,
      });
      localStorage.removeItem("register_user_profile");
    }

    setCanSaveChanges(true);
  };

  useEffect(() => {
    getUserProfile()
      .then((profile) => {
        setChangesSaved(true);
        setUserZodiac(profile.zodiac);
        setUserSocialMedia(profile.socialMedia);
        setUserWatching(profile.watchingNow);
        setTopFilm(profile.topFilm);
        setTopTv(profile.topTv);
        setTopTheatre(profile.topTheatre);
        setTopSong(profile.topSong);
        setTopBook(profile.topBook);
        setRecc(profile.topRecc);
      })
      .catch((err) => {
        //console.log(err);
      });

    getUserRatings()
      .then((ratings) => {
        const ratingSumByMovieId = ratings.reduce((accumulator, current) => {
          if (!current.movieTitle) {
            return accumulator;
          }
          const movieId = current.movieId;
          const isRatingTrue = current.rating === true;

          // Initialize counters if not present
          accumulator[movieId] = accumulator[movieId] || {
            likeCount: 0,
            dislikeCount: 0,
          };
          accumulator[movieId]["title"] = current.movieTitle || "";

          // Increment the count based on the rating value
          if (isRatingTrue) {
            accumulator[movieId].likeCount++;
          } else {
            accumulator[movieId].dislikeCount++;
          }

          return accumulator;
        }, {});
        console.log(ratingSumByMovieId);
        setMovieRatings(ratingSumByMovieId);
      })
      .catch((err) => {
        toast({
          title: `There was an issue getting your movie ratings`,
          status: "error",
          duration: 4000,
          isClosable: true,
        });
      });
  }, []);

  const isCompleted = !localStorage.getItem("register_user_profile");

  return (
    <Grid
      templateAreas={`"header header" "main main" "footer footer"`}
      gridTemplateRows={"50px 1fr 30px"}
      gridTemplateColumns={"150px 1fr"}
      pb="75px"
      color="blackAlpha.700"
    >
      <Nav />

      <GridItem pl="2" area={"main"}>
        {isCompleted && (
          <Center>
            <Box
              minWidth="980px"
              maxWidth="1200px"
              mx="5"
              mb="2"
              mt="8"
              justifyContent="left"
            >
              <Link to="/home">
                <Text as="u" color="teal">
                  &lt;&lt; Go back home
                </Text>
              </Link>
            </Box>
          </Center>
        )}
        <Center>
          <Card
            minWidth="980px"
            maxWidth="1200px"
            mx="5"
            mb="5"
            p="3"
            position="relative"
            bg={useColorModeValue("gray.100", "gray.900")}
          >
            <VStack>
              <Center>
                <Heading color="gray.600" fontSize="2xl">
                  Build your profile page
                </Heading>
              </Center>

              <Box width="100%" m="25" align="left" px="15">
                <SimpleGrid columns={3} spacing="5" mt="5">
                  <VStack width="100%" align="left" spacing={0}>
                    <Text
                      fontSize="sm"
                      ml="5"
                      color="gray.500"
                      fontWeight="bold"
                    >
                      What is your zodiac sign?
                    </Text>
                    <Select
                      value={userZodiac}
                      onChange={(e) => setUserZodiac(e.target.value)}
                      mx="4"
                      width="100%"
                      placeholder="Select your zodiac sign"
                    >
                      <option value="aries">Aries</option>
                      <option value="taurus">Taurus</option>
                      <option value="gemini">Gemini</option>
                      <option value="cancer">Cancer</option>
                      <option value="leo">Leo</option>
                      <option value="virgo">Virgo</option>
                      <option value="libra">Libra</option>
                      <option value="Scorpio">Scorpio</option>
                      <option value="Sagittarius">Sagittarius</option>
                      <option value="Capricorn">Capricorn</option>
                      <option value="Aquarius">Aquarius</option>
                    </Select>
                  </VStack>

                  <VStack width="100%" align="left" spacing={0}>
                    <Text
                      fontSize="sm"
                      ml="5"
                      color="gray.500"
                      fontWeight="bold"
                    >
                      Your preferred social media
                    </Text>
                    <Select
                      value={userSocialMedia}
                      onChange={(e) => setUserSocialMedia(e.target.value)}
                      mx="4"
                      width="100%"
                      placeholder="Select your social media platform"
                    >
                      <option value="facebook">Facebook</option>
                      <option value="instagram">Instagram</option>
                      <option value="tiktok">TikTok</option>
                      <option value="twitch">Twitch</option>
                      <option value="twitter">Twitter</option>
                      <option value="youtube">YouTube</option>
                    </Select>
                  </VStack>

                  <VStack width="100%" align="left" spacing={0}>
                    <Text
                      fontSize="sm"
                      ml="5"
                      color="gray.500"
                      fontWeight="bold"
                    >
                      What are you watching?
                    </Text>
                    <Input
                      value={userWatching}
                      onChange={(e) => setUserWatching(e.target.value)}
                      mx="4"
                      width="100%"
                      placeholder="What are you watching right now?"
                    />
                  </VStack>
                </SimpleGrid>
              </Box>
            </VStack>

            <Divider color="gray.400" my="5" />

            <Center>
              <Heading color="gray.600" fontSize="xl">
                Your Top 6
              </Heading>
            </Center>
            <Center>
              <Text>
                Select your favorites. You can change these at any time
              </Text>
            </Center>
            <SimpleGrid columns={3} spacing="5" mt="5">
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  Favorite film
                </Text>
                <Input
                  value={userTopFilm}
                  onChange={(e) => setTopFilm(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="Film"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  Favorite TV show
                </Text>
                <Input
                  value={userTopTv}
                  onChange={(e) => setTopTv(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="TV"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  Favorite Play
                </Text>
                <Input
                  value={userTopTheatre}
                  onChange={(e) => setTopTheatre(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="Theatre"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  Favorite Song
                </Text>
                <Input
                  value={userTopSong}
                  onChange={(e) => setTopSong(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="Song"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  Favorite Book
                </Text>
                <Input
                  value={userTopBook}
                  onChange={(e) => setTopBook(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="Book"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
              <Box width="100%">
                <Text fontSize="sm" color="gray.500" fontWeight="bold">
                  What would you reccomend?
                </Text>
                <Input
                  value={userRecc}
                  onChange={(e) => setRecc(e.target.value)}
                  width="100%"
                  type="text"
                  placeholder="Your media reccomendation"
                />
                {/*<Box bg="gray.300" width="100%">
                </Box>*/}
              </Box>
            </SimpleGrid>
            <Center>
              <Box mt="35px">
                <Button
                  isDisabled={!canSaveChanges}
                  onClick={submitProfile}
                  colorScheme="green"
                >
                  {canSaveChanges ? "Save changes" : "Loading..."}
                </Button>
              </Box>
            </Center>
            <Center>
              <ul>
                {profileErrors.map((err) => {
                  return (
                    <li>
                      <Text color="red.500">{err}</Text>
                    </li>
                  );
                })}
              </ul>
            </Center>
          </Card>
        </Center>

        <Center>
          {movieRatings && Object.keys(movieRatings).length !== 0 && (
            <Card maxWidth="1200px" mx="5" my="5" p="3" bg={lightGray}>
              <Flex m="2">
                <Box width="100%">
                  <Heading fontSize="2xl">Your Ratings</Heading>
                </Box>
              </Flex>
              <TableContainer>
                <Table variant="striped">
                  <Thead>
                    <Tr>
                      <Th>Title</Th>
                      <Th>Rating</Th>
                    </Tr>
                  </Thead>
                  <Tbody fontSize="sm">
                    {Object.keys(movieRatings).map((movieId) => {
                      return (
                        <Tr>
                          <Td>{movieRatings[movieId].title}</Td>
                          <Td>
                            {movieRatings[movieId].likeCount ? (
                              <Text color="green" as="b">
                                e
                              </Text>
                            ) : (
                              <Text color="red" as="b">
                                e
                              </Text>
                            )}
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
            </Card>
          )}
        </Center>

        {setUp && (
          <Center>
            <Link to="/home">
              <Button
                isDisabled={
                  (!userZodiac ||
                    !userSocialMedia ||
                    !userWatching ||
                    !userTopFilm ||
                    !userTopTv ||
                    !userTopTheatre ||
                    !userTopSong ||
                    !userTopBook ||
                    !userRecc) &&
                  changesSaved
                }
                colorScheme="blue"
              >
                Continue to homepage
              </Button>
            </Link>
          </Center>
        )}
      </GridItem>

      <Footer />
    </Grid>
  );
}

export default UserProfile;
